import React, { useMemo } from 'react';

import { Button } from 'shadcn/components/ui/Button';
import { cn } from 'shadcn/lib/utils';

import { ReceiveFooterSummary } from './ReceiveFooterSummary';
import { summarizeEnteredCasesBySource } from './receiveFooterUtils';

/**
 * @typedef {{ id: number, code: string, displayName: string }} CompanySource
 * @typedef {{ id: string, companySourceId: number | null, numCases: number, expiration: string, supplierLot: string }} PalletLine
 * @typedef {{ id: string, lines: PalletLine[] }} Pallet
 *
 * @param {Object} props
 * @param {string} [props.className]
 * @param {CompanySource[]} props.companySourceOptions
 * @param {boolean} [props.isFbmMode]
 * @param {boolean} [props.isSubmitting]
 * @param {() => void} props.onSubmit
 * @param {Pallet[]} props.pallets
 */
function ReceiveFooter({
    className,
    companySourceOptions,
    isFbmMode = false,
    isSubmitting = false,
    onSubmit,
    pallets,
}) {
    const { bySource, grandTotal } = useMemo(
        () => summarizeEnteredCasesBySource(pallets, companySourceOptions),
        [companySourceOptions, pallets],
    );

    return (
        <div className={cn('mt-4 flex items-stretch gap-3 border-t pt-4', className)}>
            <ReceiveFooterSummary bySource={bySource} grandTotal={grandTotal} isFbmMode={isFbmMode} />
            <Button
                className="shrink-0 self-stretch bg-[#4C884B] px-4 text-white hover:bg-[#4C884B]/90"
                disabled={isSubmitting}
                type="button"
                onClick={onSubmit}
            >
                Submit & Print Labels
            </Button>
        </div>
    );
}

export { ReceiveFooter };
